// These must be the first lines in src/index.js
//sort-imports-ignore
import 'react-app-polyfill/stable';

import { loadableReady } from '@loadable/component';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './components/app/app-component';

loadableReady(() => {
  const container = document.getElementById('root');
  if (container) {
    if (process.env.REACT_APP_RENDER_MODE === 'csr') createRoot(container).render(<App />);
    else {
      hydrateRoot(container, <App />);
    }
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// EMD-1462: Commented out to avoid unregistering service worker used for netcore
//serviceWorker.unregister();
